<!-- BEGIN: Left Aside -->
<button class="m-aside-left-close  m-aside-left-close--skin-dark" id="m_aside_left_close_btn" appunwraptag="">
  <i class="la la-close"></i>
</button>
<div id="m_aside_left" class="m-grid__item	m-aside-left  m-aside-left--skin-dark" style="padding-top: 20px;">
  <!-- BEGIN: Aside Menu -->
  <div id="m_ver_menu" class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark"
    data-menu-vertical="true" data-menu-scrollable="false" data-menu-dropdown-timeout="500">
    <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow" *ngIf="menuresults !== null">
      <li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open"
        routerLinkActiveOptions="{ exact: true }" aria-haspopup="true" data-menu-submenu-toggle="hover"
        *ngFor="let item of menuresults" style="border-bottom:solid; border-color: black; border-bottom-width: 1px;">
        <a href="#" class="m-menu__link m-menu__toggle">
          <i [ngClass]="item.Icon"></i>
          <span class="m-menu__link-text"> {{item.Name}} </span>
          <i class="m-menu__ver-arrow la la-angle-right"></i>
        </a>
        <div class="m-menu__submenu">
          <span class="m-menu__arrow"></span>
          <ul class="m-menu__subnav" *ngFor="let subitem of item.SubMenus">
            <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover"
              *ngIf="subitem.ScreenCode === null">
              <a href="javascript:;" class="m-menu__link m-menu__toggle">
                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                  <span></span>
                </i>
                <span class="m-menu__link-text"> {{subitem.Name}} </span>
                <i class="m-menu__ver-arrow la la-angle-right"></i>
              </a>
              <div class="m-menu__submenu" m-hidden-height="120" style="display: none; overflow: hidden;">
                <span class="m-menu__arrow"></span>
                <ul class="m-menu__subnav">
                  <li class="m-menu__item " aria-haspopup="true" *ngFor="let xsubitem of subitem.SubMenus">
                    <a routerLink="/{{xsubitem.ScreenCode}}" class="m-menu__link">
                      <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                        <span></span>
                      </i>
                      <span class="m-menu__link-text"> {{xsubitem.Name}} </span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }"
              aria-haspopup="true" *ngIf="subitem.ScreenCode !== null">
              <a routerLink="/{{subitem.ScreenCode}}" class="m-menu__link">
                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                  <span></span>
                </i>
                <span class="m-menu__link-text"> {{subitem.Name}} </span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
  <!-- END: Aside Menu -->
</div>
<!-- END: Left Aside -->